// extracted by mini-css-extract-plugin
module.exports = {"root":"_3rbUP","text":"_14ZtX"};